import * as React from "react";
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import { useAuth } from "react-oidc-context";
import { Typography } from "@mui/material";
import { useDispatchAndSave } from "@/hooks/useDispatchAndSave";
import { setLastURL } from "@/store/features/app/appSlice";

export const RequireAuth = () => {
    const dispatch = useDispatchAndSave()
    const { isLoading, isAuthenticated } = useAuth()
    const { lastURL, loading: isAppLoading, token } = useSelector((state) => state.app)
    let location = useLocation();


    React.useEffect(() => {
        const currentURL = location.pathname + (location.search ? location.search : '');
        if (isAppLoading) return;
        if (currentURL.includes("/postLogin")) return;
        if (currentURL === lastURL) return;
        if (!token) return;

        dispatch(setLastURL(currentURL));
    }, [location, dispatch, isAppLoading, lastURL, token]);



    if (isLoading) return <LoadingScreen>
        <Typography>Loading user data</Typography>
    </LoadingScreen>



    if (isAuthenticated) return <Outlet />


    const search = location.search ? location.search : '';
    return <Navigate to={`/?returnTo=${encodeURIComponent(location.pathname + search)}`} />
}